import { ServiceNameEnum } from '@Types/index';
import { getUtcTimestamp } from '@Utils/time';

export const MAIL_SERVICES = new Set([
  ServiceNameEnum.Exchange,
  ServiceNameEnum.ExchangeInline,
  ServiceNameEnum.Gmail,
  ServiceNameEnum.GmailInline,
]);

export const NOT_MAIL_SERVICES = new Set([
  ServiceNameEnum.GoogleDrive,
  ServiceNameEnum.SharePoint,
  ServiceNameEnum.Box,
  ServiceNameEnum.OneDrive,
  ServiceNameEnum.Dropbox,
  ServiceNameEnum.SalesforceSandbox,
  ServiceNameEnum.SalesforceProduction,
  ServiceNameEnum.Teams,
  ServiceNameEnum.TeamsChat,
]);

export const colors = ['#578AEF', '#04C45A', '#FF7633', '#AB6FF3', '#10B4D3'];

export function getTopSeries(
  records: Record<string, Record<string, number>>,
  limit: number,
  utcOffset: string
) {
  const series = Object.keys(records).map((key, i) => {
    const data = records[key];
    return {
      type: 'line',
      name: key.replace(/<|>/g, ' '),
      color: colors[i],
      data: Object.keys(data).map((date) => [
        getUtcTimestamp(date, utcOffset),
        data[date],
      ]) as [number, number][],
    };
  });
  series.sort(
    (a, b) =>
      b.data.reduce((acc, current) => acc + current[1], 0) -
      a.data.reduce((acc, current) => acc + current[1], 0)
  );
  series.splice(limit);
  return series;
}
